module.exports = __webpack_public_path__ + "media/images/mailchimp-1ed962ae3c925a02be67b4a80f41660f.svg";